import mapOverCriteo from "./mapOverCriteo";
import addAdvertsIntoPositions from "./addAdvertsIntoPositions";

const matchAdvertsToMightLikeProducts = (
  mightLikeProducts,
  criteoAdvertProducts,
  containerBeacons,
  adsConfig,
) => {
  if (!mightLikeProducts?.length) return [];
  if (!criteoAdvertProducts || Object.keys(criteoAdvertProducts).length === 0)
    return mightLikeProducts;

  const criteoAdverts = criteoAdvertProducts.products;
  const productsWithAdverts = [];
  let isFirstProductAnAdvert = false;
  let hasAddedContainerBeacons = false;

  mightLikeProducts.forEach((productItem, index) => {
    let vettedProduct = mapOverCriteo(productItem, criteoAdverts);

    if ("advertisement" in vettedProduct) {
      if (index === 0) {
        isFirstProductAnAdvert = true;
      }

      if (!hasAddedContainerBeacons) {
        vettedProduct.advertisement.containerBeacons = containerBeacons;
        hasAddedContainerBeacons = true;
      }

      productsWithAdverts.push(vettedProduct);
    }
  });

  const rePositionedProducts = addAdvertsIntoPositions(
    mightLikeProducts,
    productsWithAdverts,
    isFirstProductAnAdvert,
    adsConfig,
  );
  return rePositionedProducts;
};

export default matchAdvertsToMightLikeProducts;
